// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
import "@fortawesome/fontawesome-free/js/all"
import "@fortawesome/fontawesome-free/css/all"
import "bootstrap"
import "bootstrap-icons/font/bootstrap-icons"
//import "cocoon-js"

require('datatables.net-bs4')
import $ from 'jquery';
global.$ = jQuery;

// VMS custom js files
require("packs/frontend")
require('./frontend/index')
require('./frontend/AddFields')
require('./frontend/RemoveFields')
import "packs/image-preview"
//require('./frontend/addAttachment')
//require('./frontend/removeAttachment')

//const jQuery = require('jquery')
//import "cocoon"
//require("@nathanvda/cocoon")

//global.$ = global.jQuery = jQuery;
//window.$ = window.jQuery = jQuery;

$(document).on('turbolinks:load', function() {
    $('head').append('<style>.navbar.fixed-bottom{visibility:hidden}@media (orientation:portrait) and (min-height:' + $(window).height() + 'px){.navbar.fixed-bottom{visibility:visible}}@media (orientation:portrait) and (min-height:' + $(window).width() + 'px){.navbar.fixed-bottom{visibility:visible}}@media (orientation:landscape) and (height:' + $(window).width() + 'px){.navbar.fixed-bottom{visibility:visible}}@media (orientation:landscape) and (height:' + $(window).height() + 'px){.navbar.fixed-bottom{visibility:visible}}</style>')
    //$('input').focus( function() {
    //    $('.navbar.fixed-bottom').hide();
    //});
    
    //$('input').blur( function() {
    //    $('.navbar.fixed-bottom').show();
    //});

    //if (window.history && window.history.pushState) {

	//	$(//window).on('popstate', function() {
    //        alert('Back button was pressed.');
    //        $('.navbar.fixed-bottom').show();
	//	})//;
	//}

    //console.log( `on show ${$(window).height()}`);
    //$('.navbar.fixed-bottom').hide();
    //console.log(`on hide ${$(window).height()}`);
});

Rails.start()
Turbolinks.start()
ActiveStorage.start()
